import React from "react"
import ReactDOM from "react-dom"
import { useSelector } from "react-redux"

type CoverBackGroundType = {
  active: boolean
  setActive?: Function
  targetCls: string
}
export const CoverBackGround: React.FC<CoverBackGroundType> = props => {
  const parent = document.querySelector(props.targetCls)
  const Child = () => (
    <div
      className="cover-bg"
      onClick={() => props.setActive && props.setActive()}
    />
  )
  return props.active ? ReactDOM.createPortal(<Child />, parent) : null
}

export const CoverLoading: React.FC<{ targetCls: string }> = props => {
  const loadingIds = useSelector(
    (state: { PageLoad: { id: Array<string>; load: boolean } }) =>
      state.PageLoad.id
  )
  const parent = document.getElementsByClassName(props.targetCls)
  const Child = () => (
    <div className="loading-bg">
      <div className="loader" />
    </div>
  )
  return !!parent[0] && !!loadingIds && !!loadingIds.length
    ? ReactDOM.createPortal(<Child />, parent[0])
    : null
}
